import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { FullRequestHotel, Request, ResumeHotel } from 'src/types'

import { ApplicationState } from 'src/store'
import { HotelSearchType } from 'src/core/store/ducks/hotels/types'
import useReasonPolicyRule from 'src/core/hooks/use-reason-policy-rule'

import ModalSelectedHotel from './components/ModalSelectedHotel'
import MultiplePeriod from './multiple-period'
import SinglePeriod from './single-period'

type Props = {
  modalLoading?: boolean
  onSubmit?(fullRequestHotel: FullRequestHotel[]): void
  request: Request
  selectedHotels: FullRequestHotel[]
  setSelectedHotels: React.Dispatch<React.SetStateAction<FullRequestHotel[]>>
}

function List({
  modalLoading,
  onSubmit,
  request,
  selectedHotels,
  setSelectedHotels
}: Props): JSX.Element {
  const {
    hotels: { searchType }
  } = useSelector((state: ApplicationState) => ({
    hotels: state.hotels
  }))

  const [visibleModal, setVisibleModal] = useState<boolean>(false)
  const [selectedItem, setSelectedItem] = useState<ResumeHotel>()

  const policyRule = useReasonPolicyRule(
    request.request_user_data[0]?.reason_id
  )

  return (
    <>
      {searchType === HotelSearchType.SINGLE_PERIOD && (
        <SinglePeriod
          setSelectedItem={setSelectedItem}
          setVisibleModal={setVisibleModal}
        />
      )}
      {searchType === HotelSearchType.MULTIPLE_PERIOD && (
        <MultiplePeriod
          policyRule={policyRule}
          selectedHotels={selectedHotels}
          setSelectedItem={setSelectedItem}
          setVisibleModal={setVisibleModal}
        />
      )}
      <ModalSelectedHotel
        item={selectedItem}
        loading={modalLoading}
        onSubmit={onSubmit}
        request={request}
        selectedHotels={selectedHotels}
        setSelectedHotels={setSelectedHotels}
        toggle={() => {
          setVisibleModal(false)
          setSelectedItem(null)
        }}
        visible={visibleModal}
      />
      <span />
    </>
  )
}

export default List
